import { Component, OnInit } from '@angular/core';
import { StudentsService } from './service/students.service';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { PopoverController } from '@ionic/angular';
import { OpenFormComponent } from '../../../../../../component/open-form/open-form.component';
import { studentFormField } from './forms/create-student';

@Component({
	selector: 'app-students',
	templateUrl: './students.page.html',
	styleUrls: ['./students.page.scss'],
})
export class StudentsPage implements OnInit {
	studentList$: Observable<any> = new Observable();
	cohortId: any;
	constructor(
		private studentService: StudentsService,
		private location: Location,
		private popoverController: PopoverController,
	) {}

	ngOnInit() {
		const locationPath: Array<string | any> = this.location.path().split('/');
		this.cohortId = locationPath[6];

		this.studentService.loadStudentInit(this.cohortId).subscribe();
		this.studentService.loadStudentApi(this.cohortId).subscribe();
		this.studentList$ = this.studentService.fetchStudentData(this.cohortId);
	}
	isCanOpenBox = true;

	async createStudent() {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Create Student',
					form: studentFormField,
					cohortId: this.cohortId,
					onSubmitForm: this.onCreate,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}
	onCreate(ref: any, editForm: any) {
		return ref.studentService.addStudent(this.cohortId, {
			...editForm,
		});
		// return this.faqService.updateFaq(this.jobfairId, editForm.id, editForm);
	}
}
